module.exports = __webpack_public_path__ + "static/media/roomSpace-blue.0fed89c8.svg";